<template>
  <div>
    <vue-base-dialog  :dialogConfig="dialogConfig" class="selfCreateDialog">
        <div class="dialog-content">
           <p class="content">该试卷共{{this.dialogConfig.data.questionsNum}}道试题，您还有{{this.dialogConfig.data.questionsNum-this.dialogConfig.data.dataArr.length}}道试题没有回答，是否继续交卷？</p>
           <div class="button">
                <a-button class="button-cancle" shape="round" @click="cancel()">取消</a-button>
                <a-button class="button-suer" type="primary" shape="round" @click="sure()">确定</a-button>
            </div>
        </div>
    </vue-base-dialog>
  </div>
</template>

<script>
import VueBaseDialog from '@/components/VueBaseDialog'
import services from "../../../../config/services";
import { mapActions, mapState } from "vuex";
export default {
    name:"assessDialog2",
    props:{
        dialogConfig: {
          type: Object,
        }
    },
    components: {
       VueBaseDialog,
    },
    data(){
        return{
            services: services,
        }
    },
    computed: {
        ...mapState({
            loginUserInfo: (state) => state.appsLogin.appsUserInfo,
        })
    },
    methods:{
        //取消关闭窗口
        cancel(){
            this.$emit("cancleDialog",null);
        },
        sure(){
            let that = this;
            if(that.dialogConfig.data.params){
                let params = that.dialogConfig.data.params
                services.assessModify(params).then((res) => {
                    if (res.code == "0000") {
                        if(params.subtype == 2){  // 1单个题目提交2练习提交(
                            that.$router.push({
                                //跳转到再次测评
                                path: `/${that.loginUserInfo.school_code}/user/myAssess/againAssess`,
                                query: {
                                    ass_id: that.dialogConfig.data.ass_id,
                                    assessName: that.dialogConfig.data.assessName,
                                    record_id: that.dialogConfig.data.record_id,
                                    class_id: that.dialogConfig.data.class_id,
                                    tabs: 0,
                                },
                            });
                        }
                    } else {
                        this.$message.warning(res.message ? res.message : "提交失败");
                    }
                });
            }
        },
        // sure(){
        //     if(this.dialogConfig.data.dataArr.length==0){
        //         services.assessModify({
        //             ass_id:this.dialogConfig.data.ass_id
        //         }).then((res) =>{
        //             if(res.code == "0000"){
        //                 this.$router.push({
        //                     //跳转到再次测评
        //                     path:"/user/myAssess/againAssess",
        //                     query:{
        //                         ass_id:this.dialogConfig.data.ass_id,
        //                         assessName:this.dialogConfig.data.assessName,
        //                         record_id:res.data.record_id,
        //                         tabs:0,
        //                     }
        //                 });
        //             }
        //         });
        //     }else{
        //         services.assessModify({
        //             ass_id:this.dialogConfig.data.ass_id,
        //             answer_data:JSON.stringify(this.dialogConfig.data.dataArr),
        //         }).then((res) =>{
        //             if(res.code =="0000"){
        //                 this.$router.push({
        //                     //跳转到再次测评
        //                     path:"/user/myAssess/againAssess",
        //                     query:{
        //                         ass_id:this.dialogConfig.data.ass_id,
        //                         assessName:this.dialogConfig.data.assessName,
        //                         record_id:res.data.record_id,
        //                         tabs:0,
        //                     }
        //                 });
        //             }
        //         });
        //     }
           
        // },
    },

}
</script>

<style lang="less" scoped>
.dialog-content{
   padding: 20px 40px;
   width: 470px;
   padding-top: 40px;
   overflow: hidden;
}
.button{
    margin-top: 40px;
    float: right;
}
.button-cancle,.button-suer{
    border-radius: 5px;
    margin-right: 20px;
}
.content{
    color: #666666;
}
</style>